import _ from 'lodash';
import { refillTypesList } from '../RefillType/constants';

export const disableRefillCheck = (refillType) => {
  if (_.isNumber(refillType)) {
    switch (refillTypesList[refillType].value) {
    case 1:
    case 2:
      return true;
    default:
      return false;
    }
  }
  return false;
}
